"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var HslInput = /** @class */ (function (_super) {
    __extends(HslInput, _super);
    function HslInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (event, key) {
            var value = _this.props.value;
            value[key] = parseFloat(event.target.value);
            _this.setState({ value: value });
            _this.props.onChange(value);
        };
        return _this;
    }
    HslInput.prototype.render = function () {
        var _this = this;
        var _a = this.props.value, h = _a.h, s = _a.s, l = _a.l, a = _a.a;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "label-row" },
                React.createElement("label", { className: "color-type-input-label" }, "H"),
                React.createElement("label", { className: "color-type-input-label" }, "S"),
                React.createElement("label", { className: "color-type-input-label" }, "L"),
                React.createElement("label", { className: "color-type-input-label" }, "A")),
            React.createElement("div", { className: "label-row" },
                React.createElement("input", { className: "multi-color-type-input", type: "number", value: h, onChange: function (event) { return _this.handleChange(event, 'h'); }, min: "0", max: "360" }),
                React.createElement("input", { className: "multi-color-type-input", type: "number", value: s, onChange: function (event) { return _this.handleChange(event, 's'); }, min: "0", max: "100" }),
                React.createElement("input", { className: "multi-color-type-input", type: "number", value: l, onChange: function (event) { return _this.handleChange(event, 'l'); }, min: "0", max: "100" }),
                React.createElement("input", { className: "multi-color-type-input", type: "number", value: a, onChange: function (event) { return _this.handleChange(event, 'a'); }, step: "0.1", min: "0", max: "1" }))));
    };
    return HslInput;
}(react_1.Component));
exports.default = HslInput;
